import AptoideIcon from "../../../assets/icons/aptoide-badge-black.png";
import { Aptoide_Link } from "../../../constants";
import { CustomCursorContext } from "../../../contexts/cursor";
import { useContext } from "react";
import { StyledAptoide } from "./styled-aptoide";

export const AptoideButton = ({ ...props }) => {
	const { setType } = useContext(CustomCursorContext);

	return (
		<a target="_blank" rel="noopener noreferrer" href={Aptoide_Link}>
			<StyledAptoide
				src={AptoideIcon}
				alt="Get it on Aptoide"
				onMouseEnter={() => {
					setType("hover");
				}}
				onMouseLeave={() => {
					setType("");
				}}
				{...props}
			/>
		</a>
	);
};
